import $ from 'jquery';
import 'what-input';

// import Plugins
import Swiper from 'swiper/bundle';
import { Fancybox } from "@fancyapps/ui";

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).foundation();

$('.latest-news-carousel .swiper-container').each(function(){
	
	let gutter = 60;
	if($(this).find('.orange-accent').length) {
		gutter = 30;
	}
	
	const newsCarousel = new Swiper($(this)[0], {
		slidesPerView: 1,
		spaceBetween: 30,
		loop: true,
		autoplay: {
			delay: 4000,
			disableOnInteraction: false		
		},
		breakpoints: {
			640: {
				slidesPerView: 3,
				spaceBetween: 30			
			},
			1200: {
				slidesPerView: 3,
				spaceBetween: gutter			
			}
			
		}
	});
});

$(function(){
	
	/* Search toggle
	------------------------------------------------ */
	$( ".header-search-button" ).click(function(e){	
		e.preventDefault();
		if($('#header').hasClass('search-expanded')) {
			if($('.header-search-keyword').val()) {
				$(this).closest('form').submit();
			} else {
				$('#header').removeClass('search-expanded');
			}
		} else {
			$('#header').addClass('search-expanded');
			$('.header-search-keyword').focus();
		}		
	});
	$(window).click(function() {
		$('#header').removeClass('search-expanded');
	});
	$('.header-search').click(function(event){
		event.stopPropagation();
	});
	
	/* Full Size Image fix */
	$('.general-content img.size-full').each(function(){
		if($(this).parent().is('p')) {
			$(this).parent().addClass('size-full');
		}
	});
	
	/* News/Publication Listing Fix */
	if($('.section-listing-news > div:last-child').hasClass('bg-transparent')) {
		$('.section-listing-news').addClass('bg-transparent');
	}
	
	/* Dropdown Filter */
	$('.topic-dropdown-filter').on('change', function(){
		let thisVal = $(this).val();
		if(thisVal === 'all') {
			$('.featured-news-row').fadeIn();
			$('.news-grid-wrap').removeClass('is-hidden active-filtered').fadeIn();
		} else {
			$('.featured-news-row').hide();
			$('.news-grid-wrap').hide().addClass('is-hidden').removeClass('active-filtered');
			$('#' + thisVal).removeClass('is-hidden').addClass('active-filtered').fadeIn();
		}
		
		return false;		
	});
	
	/* Ajax Pagination */
	$('main#main').on('click', '.ajax-btn-wrap a', function(e){
		e.preventDefault();
		
		let topic = $(this).data('topic');
		let cat = $(this).data('cat');
		let pagenum = $(this).data('page');

		console.log(cat);
		if(topic) {
			console.log(topic);
		}
		
		if(typeof topic !== 'undefined' || typeof cat !== 'undefined') {
			let holderSelector = $(this).closest('.news-grid-wrap').find('.ajax-grid');
			let btnWrap = $(this).closest('.ajax-btn-wrap');
			
			btnWrap.addClass('btn-wrap-loading').append('<span class="the-spinner"><i class="fas fa-circle-notch fa-spin"></i></span>');
			
			if(typeof topic !== 'undefined') {
				
				// Load publications
				$.ajax({
					type: "post",
					url: local_var.ajax_url, 
					data: {
						action: 'next_pubs',
						nonce: local_var.nonce,
						topic: topic,
						pagenum: pagenum
					},
					success: function(response){
						let output = $('<div class="output"></div>').append($.parseHTML(response));				
						let dataButton = $(output).find('.ajax-btn-wrap');
						let atts = $(output).find('.data-wrap');
						$(holderSelector).append($(atts).html());				
						btnWrap.remove();
						if(dataButton.length) {
							$(dataButton).insertAfter(holderSelector);	
						}				
					}
				});
				
			} else {
				
				// Load posts
				$.ajax({
					type: "post",
					url: local_var.ajax_url, 
					data: {
						action: 'next_posts_ajx',
						nonce: local_var.nonce,
						cat: cat,
						pagenum: pagenum
					},
					success: function(response){
						let output = $('<div class="output"></div>').append($.parseHTML(response));				
						let dataButton = $(output).find('.ajax-btn-wrap');
						let atts = $(output).find('.data-wrap');
						$(holderSelector).append($(atts).html());				
						btnWrap.remove();
						if(dataButton.length) {
							$(dataButton).insertAfter(holderSelector);	
						}				
					}
				});
				
			}
			
		}
		
	});
	
	// Add a class to sections where the next section is transparent
	$('#main section').each(function(){
		if( $(this).next('section').hasClass('bg-transparent') ){
			$(this).addClass('next-bg-transparent');
		}
	});
	
});
